var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 6L18 18","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M6 18L18 6","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Close;

Close.default = Close;
